export default __webpack_public_path__ + "static/media/icon-zip.8de03f22.svg";